import { render, staticRenderFns } from "./AccountCertificateFormDDC.vue?vue&type=template&id=4b73d530&scoped=true&"
import script from "./AccountCertificateFormDDC.vue?vue&type=script&lang=ts&"
export * from "./AccountCertificateFormDDC.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCertificateFormDDC.vue?vue&type=style&index=0&id=4b73d530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b73d530",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
